//@ts-check
import React from 'react';
import Link from './Link';
import Text from './Text';

var EmailLink = function EmailLink(_ref) {
  var value = _ref.value;
  if (value) return React.createElement(Link, {
    component: "a",
    text: value,
    value: 'mailto:' + value
  });
  return React.createElement(Text, {
    value: value
  });
};

export default EmailLink;